/* eslint-disable react-hooks/exhaustive-deps */
import {Checkbox, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, TextField, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import confirm from "../../components/DialogComponent/confirm";
import PageTitle from "../../components/pageTitle/PageTitle";
import { useNavigate } from 'react-router-dom';
import { sendEmailWithFiles } from "../../services/apiservices/email";
import styles from "./Report.module.scss"
import moment from "moment";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import CircularProgress from "@mui/material/CircularProgress";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../hooks/authContext";
import { Button } from "../../components/ui/button";

const From = "noreply@proteams.io"

function EmailReportsOld(props) {
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const [to, setTo] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [toError, setToError] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [pdfData, setPdfData] = useState(null);
    const [fullReport, setFullReport] = useState(null);
    const [fullExcelReport, setFullExcelReport] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileDownloadURL, setFileDownloadURL] = useState(null);
    const [pdfFileDownladUrl, setPdfFileDownloadUrl] = useState(null);
    const [fullReportUrl, setFullReportUrl] = useState(null);
    const [fullReportExcelUrl, setFullReportExcelUrl] = useState(null);
    const [attachExcel, setAttachExcel] = useState(false);
    const [attachPdf, setAttachPdf] = useState(false);
    const [attachFullPdf, setAttachFullPdf] = useState(false);
    const [attachFullExcel, setAttachFullExcel] = useState(false);
    const [pdfFileName, setPdfFileName] = useState(null);
    const [fullPdfName, setFullPdfName] = useState(null);
    const [fullExcelName, setFullExcelName] = useState(null);
    const [showFormatError, setShowFormatError] = useState(false);
    const [reportDate, setReportDate] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openErrDialog, setOpenErrDialog] = useState(false);
    const [loader, setLoader] = useState(false);
    const [reportName, setReportName] = useState(null);
    const [name, setName] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');


    const FileName = localStorage.getItem("FileName");
    const storedData = localStorage.getItem("emailData");
    const pdf = localStorage.getItem("pdfData");
    const fullData = localStorage.getItem("fullReport")
    const fullExcelData = localStorage.getItem("fullExcelReport");
    const Date = localStorage.getItem("Date")
    const ReportsName = localStorage.getItem("ReportsName");
    const Names = localStorage.getItem("Name");
    const EndDate = localStorage.getItem("EndDate");

    const fileRoutes = {
        "ShiftReport": "/reports/Shiftreport",
        "TaskReport": "/reports/Taskreport",
        "WorkSiteReport": "/reports/Worksitereport",
        "SupplyReport": "/reports/Supplyreport",
        "IssuesReport": "/reports/Issuesreport",
        "CheckIn/CheckOut Report": "/reports/Checkincheckout",
        "TimeSheet Report": "/reports/Timesheet",
        "ActivityReport": "/reports/Activityreports",
    };

    const fileRoute = fileRoutes[fileName];

    const Dates = (date) => {
        const weekRangePattern = /^[A-Za-z]{3} [A-Za-z]{3} \d{2}, \d{4} - [A-Za-z]{3} [A-Za-z]{3} \d{2}, \d{4}$/;
        
        if (weekRangePattern.test(date)) {
          return date;
        } else {
          return moment(date).format("YYYY-MM-DD");
        }
      };
    
    useEffect(() => {

        setFileName(FileName);

        setReportDate(Dates(Date));

        setReportName(ReportsName);

        setName(Names);

        setEndDate(Dates(EndDate));

        if (pdf) {
            setPdfData(pdf)
        }

        if (storedData) {
            setEmailData(storedData);
        }

        if (fullData) {
            setFullReport(fullData);
        }

        if (fullExcelData) {
            setFullExcelReport(fullExcelData);
        }
    }, [FileName, Date, ReportsName, Names, EndDate, pdf, storedData, fullData, fullExcelData]);

    const uploadFile = (emailData, pdfData, fileName) => {
        const processFile = async (data, fileType) => {
            if (!data) {
                console.error(`Invalid ${fileType} data:`, data);
                return;
            }
    
            try {
                const contentTypeStart = data.indexOf(':') + 1;
                const contentTypeEnd = data.indexOf(';');
                const contentType = data.substring(contentTypeStart, contentTypeEnd);
    
                let Type;
                if (contentType === 'application/pdf') {
                    Type = 'application/pdf';
                } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    Type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                } else if (contentType === 'text/csv') {
                    Type = 'text/csv';
                } else {
                    console.error('Unsupported file type:', contentType);
                    return;
                }
    
                const base64DataIndex = data.indexOf('base64,') + 7;
                const base64Data = data.substring(base64DataIndex);
                const byteCharacters = atob(base64Data);
                const byteArray = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i);
                }
    
                const blob = new Blob([byteArray], { type: Type });
                const file = new File([blob], fileName, { type: Type });
    
                const timestamp = moment().valueOf().toString();
                const storage = getStorage();
                const fileRef = ref(storage, timestamp);
    
                await uploadBytes(fileRef, file);
                const downloadURL = await getDownloadURL(fileRef);
    
                const downloadURLWithName = `${downloadURL}&name=${encodeURIComponent(fileName)}`;
                const decodedFileName = decodeURIComponent(downloadURLWithName.split('name=')[1]);
    
                if (Type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    setFileDownloadURL(downloadURLWithName);
                } else if (Type === 'application/pdf') {
                    setPdfFileName(decodedFileName);
                    setPdfFileDownloadUrl(downloadURLWithName);
                } else {
                    console.error('Unknown file type:', fileName);
                }
            } catch (error) {
                console.error('Upload failed:', error);
            }
        };
    
        if (emailData) processFile(emailData, 'Excel');
        if (pdfData) processFile(pdfData, 'PDF');
    };
    
    const uploadFullData = (fullReport, fullExcelReport, fileName) => {
        const processFile = async (data, fileType) => {
            if (!data) {
                console.error(`Invalid ${fileType} data:`, data);
                return;
            }
    
            try {
                const contentTypeStart = data.indexOf(':') + 1;
                const contentTypeEnd = data.indexOf(';');
                const contentType = data.substring(contentTypeStart, contentTypeEnd);
    
                let extension = '';
                if (contentType === 'application/pdf') {
                    extension = 'pdf';
                } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    extension = 'xlsx';
                } else if (contentType === 'text/csv') {
                    extension = 'csv';
                } else {
                    console.error('Unsupported file type:', contentType);
                    return;
                }
    
                const base64DataIndex = data.indexOf('base64,') + 7;
                const base64Data = data.substring(base64DataIndex);
                const byteCharacters = atob(base64Data);
                const byteArray = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i);
                }
    
                const blob = new Blob([byteArray], { type: contentType });
                const file = new File([blob], `${fileName}.${extension}`, { type: contentType });
    
                const timestamp = moment().valueOf().toString();
                const storage = getStorage();
                const fileRef = ref(storage, timestamp);
    
                await uploadBytes(fileRef, file);
                const downloadURL = await getDownloadURL(fileRef);
    
                const fileNameWithType = `${fileName}.${extension}`;
                const downloadURLWithName = `${downloadURL}&name=${encodeURIComponent(fileNameWithType)}`;
                const decodedFileName = decodeURIComponent(downloadURLWithName.split('name=')[1]);
    
                if (extension === 'xlsx') {
                    setFullExcelName(decodedFileName);
                    setFullReportExcelUrl(downloadURLWithName);
                } else if (extension === 'pdf') {
                    setFullPdfName(decodedFileName);
                    setFullReportUrl(downloadURLWithName);
                } else {
                    console.error('Unknown file type:', fileNameWithType);
                }
            } catch (error) {
                console.error('Upload failed:', error);
            }
        };
    
        if (fullExcelReport) processFile(fullExcelReport, 'Excel');
        if (fullReport) processFile(fullReport, 'PDF');
    };


    useEffect(() => {
        if (emailData && pdfData) {
            uploadFile(emailData, pdfData, fileName);
        }

        if (fullReport && fullExcelReport) {
            uploadFullData(fullReport, fullExcelReport, fileName);
        }

    }, [emailData, pdfData, fullReport, fullExcelReport, fileName]);


    useEffect(() => {
        if (!attachExcel && !attachPdf && !attachFullPdf && !attachFullExcel) {
            setShowFormatError(true);
            return;
        }
        setShowFormatError(false);
    }, [attachExcel, attachPdf, attachFullPdf, attachFullExcel]);

    function validateEmail(email) {
        const re = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
        return re.test(email);
    }

    const isFormFilled = () => {
        return (
            to.trim() !== '' &&
            subject.trim() !== '' &&
            message.trim() !== '' &&
            (attachExcel || attachPdf || attachFullPdf || attachFullExcel)
        );
    };

    const handleSendEmail = async (e) => {
        e.preventDefault();

        setLoader(true);

        const recipients = to.split(',').map(email => email.trim());
        const excelUrl = attachExcel ? fileDownloadURL : null;
        const pdfUrl = attachPdf ? pdfFileDownladUrl : null;
        const fullExcelUrl = attachFullExcel ? fullReportExcelUrl : null;
        const fullPdfUrl = attachFullPdf ? fullReportUrl : null;
        const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;

        try {
            const response = await sendEmailWithFiles(recipients, subject, message, excelUrl, pdfUrl, fullPdfUrl, fullExcelUrl, reportDate, FileName, name, endDate);
            if (response.success === true && response.status === 200) {
                setOpenDialog(true);
                setLoader(false);
            } else {
                setOpenErrDialog(true);
                setLoader(false);
            }
        } catch (err) {
            console.error('Error sending email:', err);
            setOpenErrDialog(true);
            setLoader(false);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        localStorage.removeItem("emailData");
        localStorage.removeItem("pdfData");
        localStorage.removeItem("fullReport");
        localStorage.removeItem("fullExcelReport")
        localStorage.removeItem("FileName");
        localStorage.removeItem("Date");
        localStorage.removeItem("Name");
        localStorage.removeItem("ReportsName");
        localStorage.removeItem("EndDate");
        navigate(-2);
    };

    const handleCloseErrDialog = () => {
        setOpenErrDialog(false);
        localStorage.removeItem("emailData");
        localStorage.removeItem("pdfData");
        localStorage.removeItem("fullReport");
        localStorage.removeItem("fullExcelReport")
        localStorage.removeItem("FileName");
        localStorage.removeItem("Date");
        localStorage.removeItem("Name");
        localStorage.removeItem("ReportsName");
        localStorage.removeItem("EndDate");
        navigate(-2);
    }

    return (
        <>
            {(fileDownloadURL && pdfFileDownladUrl) || (fullReportUrl && fullReportExcelUrl) ? (
                <Container>
                    {reportName === 'Client Report' ? (
                        <PageTitle
                            pageTitle="Email Form"
                            showBreadcrumb={[
                                { label: "Home", to: "/" },
                                { label: "Reports" },
                                { label: "Client Reports", to: "/reports/clientreport"  },
                                { label: fileName, to: fileRoute}
                            ]}
                            BreadCrumbCurrentPageTitle={"Email Form"}
                            showLastSeen={true}
                        />
                    ) : (
                        <PageTitle
                            pageTitle="Email Form"
                            showBreadcrumb={[
                                { label: "Home", to: "/" },
                                { label: "Reports" },
                                { label: "Employee Reports", to: "/reports/employeereport"  },
                                { label: fileName, to: fileRoute}
                            ]}
                            BreadCrumbCurrentPageTitle={"Email Form"}
                            showLastSeen={true}
                        />
                    )}
                    <div className={'sectionBox dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]'}>
                        <div className={styles.header}>
                            <h3 className="dark:text-white">Report Name : {reportName} - {fileName}</h3>
                            <h3 className="dark:text-white">
                                {reportName === 'Client Report' ? `Client Name : ${name} Client` : `Employee Name : ${name} Employee`}
                            </h3>
                            <h3 className="dark:text-white">
                                Date Range : {reportDate} {(isMobile || isLandscape) ? '' : `to ${endDate}`}
                            </h3>
                        </div>
                        <>
                            <Grid container spacing={2} className={"mt-20 pb-15"}>
                                <Grid item sm={12} md={6}>

                                    <div className="mb-20">
                                        <TextField
                                            fullWidth={true}
                                            size="small"
                                            name="From"
                                            id="from"
                                            // label="From:"
                                            variant="outlined"
                                            value={From}
                                            placeholder="From"
                                            disabled // To keep it fixed
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <TextField
                                            fullWidth={true}
                                            size="small"
                                            name="To"
                                            id="to"
                                            // label="To"
                                            variant="outlined"
                                            value={to}
                                            onChange={(e) => {
                                                setTo(e.target.value);
                                                const isValidEmail = validateEmail(e.target.value);
                                                // Set error state based on email validity
                                                setToError(!isValidEmail);
                                            }}
                                            placeholder="To"
                                            error={toError}
                                            helperText={toError ? "Invalid email address" : ""}
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <TextField
                                            fullWidth={true}
                                            size="small"
                                            name="Subject"
                                            id="subject"
                                            // label="Subject"
                                            variant="outlined"
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                            placeholder="Subject"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <TextField
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            fullWidth
                                            id="description"
                                            // label="Add Description"
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            placeholder="Add Description"
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} className="d-flex align-items-center">
                                <div style={{ flexDirection: "column", marginTop: "-33px" }}>
                                    {showFormatError && (
                                        <div style={{ color: "red", marginBottom: "10px" }}>
                                            Please Select At Least One Format
                                        </div>
                                    )}
                                    {fileName && !(fullReportUrl && fullReportExcelUrl) ? (
                                        <div>
                                            <Checkbox
                                                checked={attachExcel}
                                                onChange={() => setAttachExcel(!attachExcel)}
                                                color="primary"
                                            />
                                            <span className="dark:text-white">{fileName}.xlsx_{reportDate}</span>
                                        </div>
                                    ) : null}
                                    {pdfFileName && !(fullReportUrl && fullReportExcelUrl) ? (
                                        <div>
                                            <Checkbox
                                                checked={attachPdf}
                                                onChange={() => setAttachPdf(!attachPdf)}
                                                color="primary"
                                            />
                                            <span className="dark:text-white">{pdfFileName}_{reportDate}</span>
                                        </div>
                                    ) : null}
                                    {fullPdfName && fullExcelName && (
                                        <>
                                            <div>
                                                <Checkbox
                                                    checked={attachFullPdf}
                                                    onChange={() => setAttachFullPdf(!attachFullPdf)}
                                                    color="primary"
                                                />
                                                <span className="dark:text-white">{fullPdfName}_{reportDate}</span>
                                            </div>
                                            <div>
                                                <Checkbox
                                                    checked={attachFullExcel}
                                                    onChange={() => setAttachFullExcel(!attachFullExcel)}
                                                    color="primary"
                                                />
                                                <span className="dark:text-white">{fileName}.xlsx_{reportDate}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Grid>
                            <Grid container className="buttonwrap mv-20">
                                <Button
                                    color="primary"
                                    className="mr-12 dark:text-white"
                                    onClick={handleSendEmail}
                                    disabled={!isFormFilled() || showFormatError || !validateEmail(to)}
                                >
                                    {loader ? <CircularProgress size={28} style={{ color: 'white' }} /> : 'Send'}
                                </Button>
                                <Button
                                    variant="outline"
                                    className=""
                                    onClick={() => {
                                        confirm(
                                            "Are you sure you want to cancel, this won't be sent?"
                                        ).then((confirmed) => {
                                            if (!confirmed) {
                                                confirm.close();
                                            } else {
                                                localStorage.removeItem("emailData");
                                                localStorage.removeItem("pdfData");
                                                localStorage.removeItem("fullReport");
                                                localStorage.removeItem("fullExcelReport")
                                                localStorage.removeItem("FileName");
                                                localStorage.removeItem("Date");
                                                localStorage.removeItem("Name");
                                                localStorage.removeItem("ReportsName");
                                                localStorage.removeItem("EndDate");
                                                navigate(-2);
                                            }
                                        }).catch(err => {
                                            console.error('Error handling confirmation:', err);
                                        });
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </>
                    </div>
                </Container>
            ) :
                <div className="loaderCSS">
                    <CircularProgress size={50} style={{ color: "green" }} />
                </div>
            }
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="sm" fullWidth
            >
                <Typography variant="body" className="mt-20 dialogTitle dark:text-white">Email Sent SuccessFully</Typography>
                <Divider className="mt-10" />
                <DialogContent className="pv-5">
                    <DialogContentText>
                        <div className="dark:text-white">
                            Thank you. Your email has been sent to {to}
                        </div>
                        <div className="dark:text-white"> Attach Files:
                            {attachExcel ? (
                                <div>
                                    <a href={`https://docs.google.com/viewer?url=${encodeURIComponent(fileDownloadURL)}`} target="_blank" rel="noopener noreferrer" className={styles.timeZone}>
                                        {fileName}.xlsx_{reportDate}
                                    </a>
                                </div>
                            ) : null}
                            {attachPdf ? (
                                <div>
                                    <a href={pdfFileDownladUrl} target="_blank" rel="noopener noreferrer" className={styles.timeZone}>{pdfFileName}_{reportDate}</a>
                                </div>
                            ) : null}
                            {attachFullPdf ? (
                                <div>
                                    <a href={fullReportUrl} target="_blank" rel="noopener noreferrer" className={styles.timeZone}>{fullPdfName}_{reportDate}</a>
                                </div>
                            ) : null}
                            {attachFullExcel ? (
                                <div>
                                    <a href={`https://docs.google.com/viewer?url=${encodeURIComponent(fullReportExcelUrl)}`} target="_blank" rel="noopener noreferrer" className={styles.timeZone}>
                                        {fileName}.xlsx_{reportDate}
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} variant="contained" className="ph-30 mb-15" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog >
            <Dialog
                open={openErrDialog}
                onClose={handleCloseErrDialog}
            >
                <DialogTitle><span className="dark:text-white">Email Sent Failed</span></DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span className="dark:text-white">
                        ! oops Your Email Can not send to {to}
                        </span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseErrDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default EmailReportsOld;